import { CuerpoLayout } from '@/components/oposiciones/CuerpoLayout';

export function OposicionesC2Layout() {
  return (
    <CuerpoLayout
      basePath="/app/oposiciones-c2"
      shortLabel="C2 Auxiliar Estado"
      accent="blue"
      areaId="c2"
      downloadsMode="oposiciones_c2"
      caseLabel="Ofimática"
    />
  );
}
